<script setup>
// NOTICE: KAPTION-INTEGRATION
// embedded-channel.DASHBOARD.3 — the Embedded tabs of an Embedded inbox's
// settings (Web · iOS · Android · Identity · Studio). The upstream web widget
// tabs stay next to these; the danger zone to turn the inbox back into a plain
// widget lives on the Settings tab (KaptionEmbeddedOptIn).
import { computed } from 'vue';
import {
  EMBEDDED_PLATFORMS,
  EMBEDDED_TAB_KEYS,
} from 'dashboard/helper/kaptionEmbedded';
import KaptionEmbeddedWeb from './embedded/KaptionEmbeddedWeb.vue';
import KaptionEmbeddedApps from './embedded/KaptionEmbeddedApps.vue';
import KaptionEmbeddedIdentity from './embedded/KaptionEmbeddedIdentity.vue';
import KaptionWidgetStudioSettings from './KaptionWidgetStudioSettings.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
  tab: { type: String, required: true },
});

const platform = computed(
  () =>
    ({
      [EMBEDDED_TAB_KEYS.IOS]: EMBEDDED_PLATFORMS.IOS,
      [EMBEDDED_TAB_KEYS.ANDROID]: EMBEDDED_PLATFORMS.ANDROID,
    })[props.tab]
);
</script>

<template>
  <KaptionEmbeddedWeb v-if="tab === EMBEDDED_TAB_KEYS.WEB" :inbox="inbox" />
  <KaptionEmbeddedApps
    v-else-if="platform"
    :key="platform"
    :inbox="inbox"
    :platform="platform"
  />
  <KaptionEmbeddedIdentity
    v-else-if="tab === EMBEDDED_TAB_KEYS.IDENTITY"
    :inbox="inbox"
  />
  <KaptionWidgetStudioSettings
    v-else-if="tab === EMBEDDED_TAB_KEYS.STUDIO"
    :inbox="inbox"
    embedded
  />
</template>
